import React from "react";
import HeroArea from "./HeroArea";
import BlogDetailsArea from "./BlogDetailsArea";

const BlogDetails = () => {
  return (
    <>
      <HeroArea />
      <BlogDetailsArea />
    </>
  );
};

export default BlogDetails;
